import { render, staticRenderFns } from "./Empreendimentos.vue?vue&type=template&id=2cab8e82&scoped=true&lang=pug"
import script from "./Empreendimentos.vue?vue&type=script&lang=js"
export * from "./Empreendimentos.vue?vue&type=script&lang=js"
import style0 from "./Empreendimentos.styl?vue&type=style&index=0&id=2cab8e82&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab8e82",
  null
  
)

export default component.exports